<template>
  <div>
    <el-select ref="select" @focus="clear" @hook:mounted="clear" @visible-change="clear" @blur.native.capture="onblur" :popper-append-to-body="false" :filterable="true" :remote="true" :remote-method="handleRemote" :value="value" value-key="id" :placeholder="$t('category.category')" :size="size" @input="change($event)" :clearable="true">
      <el-option v-if="!config" label="----------" :value="emptyValue" />
      <el-option v-for="item in optionsReader()" :key="item.id" :label="item.title ? item.title + '【'+ item.desc +'】' : item.desc" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import { fetchCategoryList } from '../api/product-category'
import {debounce} from '../../utils'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: [],
      configOptions: null,
      optionsReader: () => { if (this.config) { return this.configOptions } return this.options },
      serach: [],
      res: [],
      isSerach: false,
      formData: {
        pageIndex: 1,
        pageSize: 10,
        serachPageIndex: 1,
        serachPageSize: 20
      },
      dropDownValue: ''
    }
  },
  created () {
    fetchCategoryList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
      this.configOptions = this.config ? this.options.filter((item) => { return item.id === parseInt(this.config.selected) }) : this.options
    })
  },
  mounted () {
  },
  props: ['value', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    clear (async) {
      this.dropDownValue = ''
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const { select } = this.$refs
            const input = select.$el.querySelector('.el-input__inner')
            input.removeAttribute('readonly')
          }, 200)
        }
      })
    },
    // 失去焦点时，需要把软键盘收起
    onblur () {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur()
        }
      })
    },
    handleRemote (data) {
      debounce(() => {
        this.dropDownValue = data
        this.options = []
        this.handleUpdate(false)
      }, 2000, true)()
    },
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate (loadMore = false) {
      let q = []
      let query = {}
      if (this.dropDownValue) {
        if (loadMore) {
          this.formData.serachPageIndex++
          this.serach = this.options
        }
        this.isSerach = true
        query.limit = this.formData.serachPageSize
        query.page = this.formData.serachPageIndex
        q.push(['like', 'title', '%' + this.dropDownValue + '%'].join(','))
      } else {
        if (loadMore) {
          this.formData.pageIndex++
          this.res = this.options
        }
        this.isSerach = false
        query.limit = this.formData.pageSize
        query.page = this.formData.pageIndex
      }
      query.q = q.join('&')
      fetchCategoryList(query).then((res) => {
        const _res = res.data.map((item) => { item.user_id = parseInt(item.user_id); return item })
        if (this.isSerach) {
          this.options = [...this.serach, ..._res]
        } else {
          this.options = [...this.res, ..._res]
        }
      })
    },
    loadMore () {
      this.handleUpdate(true)
    }
    // handleUpdate () {
    //   fetchProductList({limit: 0}).then((res) => {
    //     this.options = res.data
    //   })
    // }
  },
  watch: {
    config: function (val, old) {
      this.configOptions = val ? this.options.filter((item) => { return item.id === parseInt(val.selected) }) : this.options
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/ProductCategorySelect.vue